import axios from 'axios';
import { editUserConfigsAction } from './EditUserConfigsSlice';

const editUserConfigs = (token, body) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_DEV_URI}/user/config`;
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(url, body, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(editUserConfigsAction.editUserConfigsSuccess(result.data));
      return result.data;
    } catch (e) {
      dispatch(editUserConfigsAction.editUserConfigsFailure(e.response?.data ?? e.message));
      return null
    }
  };
};

export default editUserConfigs;